import { DayHours } from '@types';

export type OperatingHours = {
  monday: DayHours;
  tuesday: DayHours;
  wednesday: DayHours;
  thursday: DayHours;
  friday: DayHours;
  saturday: DayHours;
  sunday: DayHours;
  publicHoliday: DayHours;
};

export const defaultOperatingHours: OperatingHours = {
  monday: { enabled: true, open: '8:00', close: '17:00' },
  tuesday: { enabled: true, open: '8:00', close: '17:00' },
  wednesday: { enabled: true, open: '8:00', close: '17:00' },
  thursday: { enabled: true, open: '8:00', close: '17:00' },
  friday: { enabled: true, open: '8:00', close: '17:00' },
  saturday: { enabled: false, open: null, close: null },
  sunday: { enabled: false, open: null, close: null },
  publicHoliday: { enabled: false, open: null, close: null },
};
